export default __webpack_public_path__ + "static/media/GE.701bc323.svg";